import { useSyncExternalStore } from 'react'
import { CollectionState } from '../collection-state'

export function useSearchRecords (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('searchRecordsChanged', callback),
    () => state.searchRecords
  )
}
